import React from 'react'
import { Create, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin'

const ReminderConfigsCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm redirect="show">
        <TextInput source="description" validate={required()} />
        <ReferenceInput source="client.id" reference="clients" perPage={100} validate={required()}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput source="module_type.id" reference="modules" perPage={100} label="module" validate={required()}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="sendgrid_template_id" validate={required()} />
        <NumberInput source="days" validate={required()} />
        <NumberInput source="order" validate={required()} />
      </SimpleForm>
    </Create>
  )
}

export default ReminderConfigsCreate
